import { db } from "../firebaseConfig";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  getDoc
} from "firebase/firestore";

export interface Equipo {
  id?: string;
  nombre: string;
  descripcion?: string;
  socios: string[];
  imagenCoche?: string; // URL de la imagen del coche/skin
}

const equiposCollection = collection(db, "equipos");

export const EquipoService = {
  async create(equipo: Omit<Equipo, "id">) {
    // Asegura que socios siempre sea array
    const equipoToSave = { ...equipo, socios: Array.isArray(equipo.socios) ? equipo.socios : (equipo.socios ? [equipo.socios] : []) };
    const docRef = await addDoc(equiposCollection, equipoToSave);
    return { ...equipoToSave, id: docRef.id };
  },

  async getAll(): Promise<Equipo[]> {
    const snapshot = await getDocs(equiposCollection);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as Equipo));
  },

  async getById(id: string): Promise<Equipo | null> {
    const docRef = doc(db, "equipos", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() } as Equipo;
    }
    return null;
  },

  async update(id: string, equipoData: Partial<Equipo>) {
    if (!id) throw new Error('ID de equipo no definido para update');
    // Asegura que socios siempre sea array
    const equipoToSave = equipoData.socios !== undefined ? { ...equipoData, socios: Array.isArray(equipoData.socios) ? equipoData.socios : (equipoData.socios ? [equipoData.socios] : []) } : equipoData;
    const docRef = doc(db, "equipos", id);
    await updateDoc(docRef, equipoToSave);
  },

  async delete(id: string) {
    if (!id) throw new Error('ID de equipo no definido para delete');
    const docRef = doc(db, "equipos", id);
    await deleteDoc(docRef);
  }
};

export default EquipoService;
